import type { DealerBrandingPageResponse } from "@finn-no/mobility-dealer-types";

export enum TabId {
  AboutUs = "aboutUs",
  Campaigns = "campaigns",
  DealerAds = "dealerAds",
  ImageGallery = "imageGallery",
  Employees = "employees",
  OtherLocations = "otherLocations",
}

export function getAvailableTabs(data: DealerBrandingPageResponse): TabId[] {
  const tabs: TabId[] = [TabId.AboutUs];

  // Uncomment the following lines to enable additional tabs based on data availability
  // if (data.campaigns?.length) {
  // 	tabs.push(TabId.Campaigns);
  // }
  //
  if (data.latestAds?.length) {
    tabs.push(TabId.DealerAds);
  }
  if (data.imageGallery?.length && data.imageGallery?.length >= 3) {
    tabs.push(TabId.ImageGallery);
  }
  if (data.salesPersons?.length) {
    tabs.push(TabId.Employees);
  }
  if (data.otherLocations?.length) {
    tabs.push(TabId.OtherLocations);
  }

  return tabs;
}
